<template>
  <div class="accountRegistration">
    <el-form
      label-position="left"
      :model="accountRegistration"
      label-width="74px"
    >
      <el-form-item label="手机号">
        <el-input
          v-model="accountRegistration.phone"
          placeholder="请输入..."
        ></el-input>
      </el-form-item>
      <div class="accountRegistrationItem">
        <div class="set_">
          <el-form-item label="验证码">
            <el-input
              v-model="accountRegistration.verificationCode"
              placeholder="请输入..."
            ></el-input>
          </el-form-item>
        </div>
        <div class="botton_" @click="smsTemplateSendMsgSecond()">
          {{ show ? "获取验证码" : count }}
        </div>
      </div>

      <el-form-item label="密码">
        <el-input
          v-model="accountRegistration.password"
          type="password"
          placeholder="请输入..."
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input
          type="password"
          v-model="accountRegistration.yespassWord_"
          placeholder="请输入..."
        ></el-input>
      </el-form-item>
      <div class="radioWap">
        <div class="radio_">
          <div class="left_" @click="radioSetting">
            <img src="@/assets/images/radioIconActive.png" v-if="radioState" />
            <img src="@/assets/images/radioIcon.png" v-else />
          </div>
          <div class="right_" @click="radioSetting">
            我同意并遵守<span @click="agreementJump">用户协议</span>
          </div>
        </div>
        <div class="registeredBtn">
          <div @click="loginPhoneRegister">注册</div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  loginPhoneRegister,
  smsTemplateSendMsgSecond,
} from "../../api/interfaceList.js";
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
export default {
  name: "registeredPage",
  data() {
    return {
      radioState: false,
      accountRegistration: {
        phone: "",
        verificationCode: "",
        password: "",
        yespassWord_: "",
      },
      show: true,
      count: "",
      timer: null,
    };
  },
  created() {},
  methods: {
    agreementJump() {
      this.$router.push("/agreementPage");
    },
    smsTemplateSendMsgSecond() {
      let { phone } = this.accountRegistration;
      if (phone) {
        smsTemplateSendMsgSecond({
          phone,
          type: 2,
        })
          .then((res) => {
            console.log(res);
            if (res.code == 1) {
              this.getCode();
            } else {
              ElMessage({
                message: res.message,
                type: "warning",
              });
            }
          })
          .catch(() => {
            ElMessage({
              message: "请检查号码格式是否正确",
              type: "warning",
            });
          });
      } else {
        ElMessage({
          message: "手机号不能为空",
          type: "warning",
        });
      }
    },
    loginPhoneRegister() {
      if (this.radioState) {
        let { phone, password, verificationCode, yespassWord_ } =
          this.accountRegistration;
        if (password == yespassWord_ && password != "") {
          loginPhoneRegister({
            phone,
            password,
            verificationCode,
          }).then((res) => {
            if (res.code == 1) {
              let json = {
                key: 1,
                isOk: true,
                userCode: res.data.userCode,
              };
              Cookies.set("userInformation", JSON.stringify(res.data));
              this.$store.commit("isLoginSetting", false);
              this.$emit("isOk", json);
            } else {
              ElMessage({
                message: res.message,
                type: "warning",
              });
            }
          });
        } else {
          ElMessage({
            message: "请检查输入框内容",
            type: "warning",
          });
        }
      } else {
        ElMessage({
          message: "请确认用户协议",
        });
      }
    },
    radioSetting() {
      this.radioState = !this.radioState;
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
  components: {},
};
</script>
<style lang="scss">
.accountRegistration .el-form-item__label {
  font-size: 12px;
}
</style>
<style lang="scss" scope>
.accountRegistration {
  width: 506px;
  .radioWap {
    width: 100%;
    display: flex;
    // justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    .registeredBtn {
      width: 432px;
      margin: 40px 0;
      div {
        width: 240px;
        height: 40px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        background: #008aea;
        border-radius: 8px;
        cursor: pointer;
      }
      div:hover {
        background: #6dbbfc;
        transition: 0.4s all;
      }
    }
    .radio_ {
      width: 432px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .right_ {
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        font-weight: 700;
        span {
          color: #008aea;
        }
      }
      .left_ {
        width: 24px;
        font-size: 0;
        img {
          width: 100%;
        }
      }
    }
  }
  .agreement {
    font-size: 13px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    font-weight: 700;
    span {
      color: #008aea;
    }
  }
  .accountRegistrationItem {
    display: flex;
    justify-content: space-between;
    .set_ {
      width: 350px;
    }
    .botton_ {
      width: 144px;
      height: 40px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      background: #008aea;
      border-radius: 8px;
      cursor: pointer;
    }
  }
}
</style>
